import React, { useCallback, useState } from 'react';
import AsyncSelect from 'react-select/async';
import { components } from 'react-select';
import PropTypes from 'prop-types';
import instruments from '../../client-api/modules/Instruments';

const SingleValue = (props) => (
    <components.SingleValue {...props}>
        {props?.data?.shortName}
    </components.SingleValue>
);

const ValueContainer = ({ children, ...innerProps }) => (
    components.ValueContainer && (
        <components.ValueContainer {...innerProps}>
            {!!children && innerProps.selectProps.showSearchIcon && <span className="icon search-gray" />}
            <div className={`${innerProps.selectProps.showSearchIcon ? 'ml-3' : 'ml-0'}`}>
                {children}
            </div>
        </components.ValueContainer>
    )
);

const NoInstrumentFound = (
    <div className='text-center no-instrument p-2'>
        <div className='no-results'>No results found</div>
        <div className='no-result-message'>Please check for spelling</div>
    </div>
);

const InstrumentLookup = (props) => {
    const {
        handleOnChange,
        placeholderText,
        NotFoundMessage,
        instrumentTypes,
        isDisabled,
        limit,
        showSearchIcon,
    } = props;

    const [showMenu, setShowMenu] = useState(false);

    const handleInputChange = useCallback((typedOption) => {
        if (typedOption?.length > 1) {
            setShowMenu(true);
            return;
        }

        setShowMenu(false);
    }, []);

    const LoadingIndicator = (props) => {
        if (showMenu === false) {
            return null;
        }

        return (
            <components.LoadingIndicator {...props}>
                {props}
            </components.LoadingIndicator>
        );
    };

    const promiseOptions = (inputValue) => {
        if (inputValue.length <= 1) {
            return [];
        }

        return instruments.getInstruments(inputValue, limit, instrumentTypes)
            .then((data) => data?.map((item) => ({
                value: {
                    instrumentId: item?.instrumentId,
                    name: item?.name,
                    market: item?.marketGroup,
                    tickerSymbol: item?.tickerSymbol,
                },
                shortName: item.name,
                label: <div className='row px-3 py-1 w-100'>
                    <span className="dropdown-ticker-symbol col-2">{item.tickerSymbol}</span>
                    <span className="col">{item.name}</span>
                    <span className="col-2">({item.marketGroup})</span>
                </div>,
            })));
    };

    const colourStyles = {
        control: () => ({ display: 'flex', background: 'transparent' }),
        singleValue: (provided) => ({
            ...provided,
            color: 'white',
        }),
    };

    return (
        <>
            <AsyncSelect
                classNamePrefix={'select'}
                className={'select instrument-lookup'}
                name={'tickerSymbol'}
                loadOptions={promiseOptions}
                placeholder={placeholderText}
                onChange={handleOnChange}
                closeMenu={false}
                noOptionsMessage={() => NotFoundMessage}
                components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                    ValueContainer,
                    SingleValue,
                    LoadingIndicator,
                }}
                openMenuOnClick={false}
                maxMenuHeight={600}
                styles={colourStyles}
                isDisabled={isDisabled}
                showSearchIcon={showSearchIcon}
                onInputChange = { handleInputChange }
                menuIsOpen={ showMenu }
            />
        </>
    );
};

InstrumentLookup.propTypes = {
    handleOnChange: PropTypes.func,
    placeholderText: PropTypes.string,
    NotFoundMessage: PropTypes.object,
    instrumentTypes: PropTypes.array,
    isDisabled: PropTypes.bool,
    limit: PropTypes.number,
    showSearchIcon: PropTypes.bool,
};

InstrumentLookup.defaultProps = {
    placeholderText: 'Enter search',
    NotFoundMessage: NoInstrumentFound,
    instrumentTypes: [],
    limit: 100,
    showSearchIcon: false,
};

export default InstrumentLookup;
